import { PlusOutlined } from '@ant-design/icons'
import { Image, Upload, UploadFile, UploadProps } from 'antd'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './pure-image-upload.module.scss'
import { getBase64 } from '../../../utils/base64/get-base-64'
import { FileType } from '../../types'

type PureImageUploadProps = {
  disabled?: boolean
  label?: string
  required?: boolean
}

export const PureImageUpload = ({ disabled, label, required }: PureImageUploadProps) => {
  const { t } = useTranslation()
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [fileList, setFileList] = useState<UploadFile[]>([])

  const uploadButton = (
    <button
      style={{ border: 0, background: 'none' }}
      type="button"
    >
      <PlusOutlined />
      <div className={styles.uploadBtn}>{t('common.upload')}</div>
    </button>
  )

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType)
    }

    setPreviewImage(file.url || (file.preview as string))
    setPreviewOpen(true)
  }

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => setFileList(newFileList)

  return (
    <div className={clsx('d-flex flex-column', styles.imageUploadStyles)}>
      <div className="label d-block mt-2 mb-1 fs-6">
        {label}
        {required ? <span className={clsx(styles.required)}>*</span> : null}
      </div>
      <Upload
        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
        disabled={disabled}
        fileList={fileList}
        listType="picture-card"
        onChange={handleChange}
        onPreview={handlePreview}
      >
        {uploadButton}
      </Upload>
      {previewImage ? (
        <Image
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
          }}
          src={previewImage}
          style={{ display: 'none' }}
        />
      ) : null}
    </div>
  )
}
